<template>
    <div>
      <input 
        type="number" 
        v-model="orbitSpares" 
        class="form-control" 
        :min="0" 
        :max="100"
        @input="formatNumber"
      >
    </div>
  </template>
  
  <script>
  export default {
    name: 'FieldIntegrationDays',
    props: {
      value: Number
    },
    data() {
      return {
        orbitSpares: this.value
      };
    },
    watch: {
      value(newVal) {
        this.orbitSpares = newVal;
      },
      orbitSpares(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      formatNumber() {
        this.orbitSpares = Number(this.orbitSpares).toLocaleString();
      }
    }
  }
  </script>
  